module.exports = __webpack_public_path__ + "static/media/sendgrid-example.55e9845e.webp";